import styled from 'styled-components'

export const NavHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  position: sticky;
  top: 0;
  background-color: ${props => props.bgColor};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
  }
`

export const WebsiteLogo = styled.img`
  width: 120px;

  @media screen and (min-width: 768px) {
    width: 160px;
  }
`

export const ContentContainer = styled.ul`
  display: flex;
  list-style-type: none;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`

export const ContentListItem = styled.li`
  display: flex;
  align-items: center;
`

export const ThemeButton = styled.button`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 24px;
  padding: 8px 16px;
  color: ${props => props.color};
  background-color: ${props => (props.isDarkTheme ? '#333' : '#0967d2')};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${props => (props.isDarkTheme ? '#444' : '#0855a8')};
  }
`

export const ProfileImage = styled.img`
  height: 36px;
  width: 36px;
  border-radius: 50%;
  margin: 0 10px;
  border: 2px solid ${props => props.themeBorderColor || '#fff'};
`

export const LogoutButton = styled.button`
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  color: #ffffff;
  background-color: #dc2626;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #b91c1c;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 300px;
  background-color: ${props => props.bgColor || '#f9f9f9'};
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`

export const ModalDesc = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  color: ${props => props.color || '#333'};
  margin: 20px;
  text-align: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
`

export const CloseButton = styled.button`
  background-color: transparent;
  border: 1px solid #bbb;
  padding: 10px 20px;
  color: #666;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }
`

export const ConfirmButton = styled.button`
  background-color: #dc2626;
  border: none;
  padding: 10px 20px;
  color: white;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #b91c1c;
  }
`

export const AlignColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
